import i18n from '../i18n'

// Just the symbol, for places that label a field rather than render an amount (the discount's $/%
// toggle). Intl is the only source of it, so read it off a formatted zero.
export function currencySymbol(currency) {
  if (!currency?.code) { return '$' }

  try {
    const parts = new Intl.NumberFormat(i18n.language || 'en', { style: 'currency', currency: currency.code }).formatToParts(0)
    return parts.find(part => part.type === 'currency')?.value || '$'
  } catch {
    // An unrecognised currency code makes Intl throw; the symbol is cosmetic, so fall back.
    return '$'
  }
}

export function displayWithCurrency(amount, currency, noDecimals = false) {
  noDecimals = currency?.zeroDecimal || noDecimals

  return new Intl.NumberFormat(i18n.language || 'en', {
    maximumFractionDigits: noDecimals ? 0 : 2,
    minimumFractionDigits: noDecimals ? 0 : 2,
    style: 'currency',
    currency: currency?.code,
  }).format(amount)
}

// a quoted line's total already carries its tax; lines built outside a quote have only an amount
export function chargedAmount(line) {
  return line.total ?? line.amount
}

export function totalsByCurrency(lines) {
  const totals = {}

  lines.forEach(line => {
    const code = line.currency.code

    totals[code] = { amount: (totals[code]?.amount || 0) + chargedAmount(line), currency: line.currency }
  })

  return Object.values(totals)
}

export function displayTotals(totals) {
  return totals.map(total => displayWithCurrency(total.amount, total.currency)).join(' + ')
}
